import axios from "axios";
import type {ILocationStore} from "@/store/states/ILocationStoreState.interface";
import type {IOrderFalseDriverState} from "@/store/states/IOrderFalseDriverState.interface";
import {Store} from "vuex";
import NameOfHelper from "../helpers/nameOfHelper";
import apiService from "../services/apiService";

export default class RentService
{
    private store = <Store<any>|null>null;

    constructor(store: Store<any>) {
        this.store = store;
    }

    /**
     * NOTE. Should be used only with IOrderFalseDriverState set in the constructor
     */

    ensureCompanyAddressPreselect(state: IOrderFalseDriverState): void {
        const nameOf = (c) => NameOfHelper.obj(c);

        if (state.destination
            || ! this.store?.state.company.rent_service_without_driver_default_address
        ) {
            return;
        }

        const address = this.store.state.company.rent_service_without_driver_default_address;

        axios.get(apiService.googleApiDirectionsTextSearchEndpoint() + '?q=' + address)
            .then(response => {
                this.store?.commit( 'orderFalseDriver/SET_STATE_PROP_VALUE', [
                    {prop: nameOf(() => state.destination), value: <ILocationStore>response.data},
                ]);
            });
    }
}